import { readConsentFromBrowser } from './document-cookie';
import { isInternalQaExcludedInBrowser } from '../analytics/internal-qa-exclusion';
import { isProductionHostname } from '../analytics/production-hostnames';
import { VITE_DEV } from '../env/vite-env';

/**
 * True when the ONLY thing stopping client analytics is that the visitor hasn't made a consent
 * choice yet. Mirrors isClientAnalyticsAllowed()'s environment guards (dev, non-production host,
 * internal QA) so nothing is ever queued where it could never be sent, and an explicit rejection
 * (cookie present, analytics: false) is not "pending": that visitor said no.
 */
export function isClientAnalyticsPendingConsent(): boolean {
  if (typeof window === 'undefined') return false;
  if (VITE_DEV) return false;
  if (!isProductionHostname(window.location.hostname)) return false;
  if (isInternalQaExcludedInBrowser()) return false;
  return readConsentFromBrowser() === null;
}
